
export const formatLinkVideo = ( link, setReadyLink ) => {
    if(link.split("youtu.be")[1]){
        setReadyLink(link.split(".be/")[1])
    }else{
        const sec = link.split('=');
        const newURL = sec[1] ? sec[1].split('&')[0] : sec[1];
        setReadyLink(newURL);
    }
}